import React from 'react';

import Header from '../../layout/Header.jsx';
import ListThemeReports from '../../lists/ListThemeReports.jsx';

const PageThemeReports = () => (
  <div>
    <Header>ThemeReports</Header>
    <ListThemeReports />
  </div>
);

export default PageThemeReports;
